<template>
  <div id="header">
    <!-- <div class="top-header">
      <div class="container">
        <div class="row justify-content-end">
          <div class="col-6 col-lg-2 text-right">
            <a href="#">
              <img src="../assets/img/phone.png" class="img header-icon mr-2" alt="Phone">
              081 234 5678
            </a>
          </div>
          <div class="col-2 col-md-1 text-right">
            <a href="#">
              <img src="../assets/img/facebook.png" class="img header-icon" alt="Facebook">
            </a>
          </div>
        </div>
      </div>
    </div> -->
    <div class="bottom-header">
      <div class="container">
        <div class="row justify-content-between align-items-center">
          <div class="col-2">
            <router-link :to="{ name: 'Home' }" title="K-Food">
              <img src="../assets/img/logo.svg" alt="K-Food" class="img d-block logo">
            </router-link>
          </div>
          <div class="col">
            <div class="row">
              <div class="col-12 d-flex justify-content-end">
                <nav class="nav d-none d-lg-flex">
                  <router-link :to="{ name: menu.path }" class="nav-link" v-for="(menu, key) in menus" v-bind:key="key">{{ menu.name }}</router-link>
                </nav>
                <nav class="nav language-switcher align-items-center ml-5 d-none d-lg-flex">
                  <button class="btn btn-lang pt-0 pb-0" type="button" v-bind:class="{ active: lang=='th' }" v-on:click="setLang('th')">TH</button>
                  <button class="btn btn-lang pt-0 pb-0 ml-3" type="button" v-bind:class="{ active: lang=='en' }" v-on:click="setLang('en')">EN</button>
                </nav>
                <div class="nav nav search">
                  <!-- <button class="btn btn-light ml-3" type="button" v-on:click="openSearch"><i class="fa fa-search"></i></button> -->
                  <button class="btn d-lg-none ml-3 p-0" id="hamburger" type="button" v-on:click="openMenu" v-bind:class="{ active: isMenuActive }">
                    <span></span>
                    <span></span>
                    <span></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <transition name="down">
      <div id="menu-container" class="d-lg-none" v-if="isMenuActive">
        <div class="container-fluid p-0">
          <ul class="nav">
            <li class="nav-item w-100" v-for="(menu, key) in menus" v-bind:key="key" v-on:click="closeMenu">
              <router-link :to="{ name: menu.path }" class="nav-link text-white">{{ menu.name }}</router-link>
            </li>
          </ul>
          <nav class="nav language-switcher align-items-center">
            <button class="btn btn-lang pt-0 pb-0" type="button" v-bind:class="{ active: lang=='th' }" v-on:click="setLang('th')">TH</button>
            <button class="btn btn-lang pt-0 pb-0 ml-3" type="button" v-bind:class="{ active: lang=='en' }" v-on:click="setLang('en')">EN</button>
          </nav>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div id="search-wrapper" v-show="showSearch">
        <button type="button" class="close-search" v-on:click="closeSearch">
          <span></span>
          <span></span>
        </button>
        <div class="container pt-5">
          <div class="row mt-5 justify-content-center">
            <div class="col-12 col-lg-7">
              <input type="text" ref="search" v-model="search" v-bind:placeholder="searchHint">
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'KHeader',
  data () {
    return {
      showSearch: false,
      search: '',
      lang: this.$router.history.current.params.lang,
      searchHint: '',
      menus: [],
      isMenuActive: false
    }
  },
  created () {
    if (this.lang === 'th') {
      this.searchHint = 'ค้นหาผลิตภัณฑ์ เช่น กาแฟคั่วบดสำเร็จรูป'
      this.menus = [
        {
          name: 'หน้าแรก',
          path: 'Home'
        },
        {
          name: 'บริษัทผู้ผลิต',
          path: 'Manufacturer'
        },
        {
          name: 'ติดต่อเรา',
          path: 'Contact'
        }
      ]
    } else {
      this.searchHint = 'Find products. e.g., Roasted and Ground Coffee.'
      this.menus = [
        {
          name: 'Home',
          path: 'Home'
        },
        {
          name: 'Manufacturer',
          path: 'Manufacturer'
        },
        {
          name: 'Contact',
          path: 'Contact'
        }
      ]
    }
  },
  methods: {
    openSearch () {
      this.showSearch = true
      this.isMenuActive = false
      this.$nextTick(() => this.$refs.search.focus())
    },
    closeSearch () {
      this.showSearch = false
    },
    setLang (language) {
      let current = this.$router.history.current.name
      this.$router.push({ name: current, params: { lang: language } })
      this.$router.go()
    },
    openMenu () {
      this.isMenuActive = !this.isMenuActive
    },
    closeMenu () {
      let self = this
      setTimeout(function () {
        self.isMenuActive = false
      }, 200)
    }
  }
}
</script>

<style lang="sass">
</style>



// WEBPACK FOOTER //
// src/components/Header.vue